<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">UPDATE MASTER SKU</h6>
                  <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form class="forms-sample" @submit.prevent="submitData" method="POST">

                    <!-- <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('tarifMasterId')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          
                            <input
                            type="text"
                            class="form-control"
                            id="tarifMasterId"
                            :placeholder="$t('tarifMasterId')"
                            v-model="forms.tarifMasterId"
                            required
                          />
  
  
  
                          <div v-if="errors.tarifMasterId">
                            <div
                              v-for="error in errors.tarifMasterId"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div> -->


                    <div class="row mb-2">
                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">{{
                          $t('customerId')
                        }}</label>

                        <v-select :options="fetchCustomer" v-model="customer" label="code" return-object
                          @search="asyncCustomer">
                          <template slot="option" slot-scope="option">
                            {{ option.customer_id }} | {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>
                        <div v-if="errors.customerId">
                          <div v-for="error in errors.customerId" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>



                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">SKU</label>

                        <input type="text" class="form-control" id="sku" placeholder="SKU" v-model="forms.sku" required />

                        <div v-if="errors.sku">
                          <div v-for="error in errors.sku" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>



                      <div class="col-lg-4">
                        <label for="defaultconfig" class="col-form-label">SKU Description(S)</label>

                        <input type="text" class="form-control" id="skuDescr1" placeholder="SKU Description"
                          v-model="forms.skuDescr2"  />

                        <div v-if="errors.skuDescr2">
                          <div v-for="error in errors.skuDescr2" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>





                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" class="form-check-input" id="activeFlag" v-model="activeFlag">
                          <label class="form-check-label" for="activeFlag">
                            Active Flag 
                          </label>
                        </div>

                        <div v-if="errors.activeFlag">
                          <div v-for="error in errors.activeFlag" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                    </div>


                    <div class="row  mb-2">
                      <div class="col-lg-8 required">
                        <label for="defaultconfig" class="col-form-label">SKU Description(L)</label>

                        <input type="text" class="form-control" id="skuDescr2" placeholder="SKU Description"
                          v-model="forms.skuDescr1" required />

                        <div v-if="errors.skuDescr1">
                          <div v-for="error in errors.skuDescr1" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" class="form-check-input" id="akitFlag" v-model="kitFlag">
                          <label class="form-check-label" for="kitFlag">
                            Kit Flag
                          </label>
                        </div>

                        <div v-if="errors.kitFlag">
                          <div v-for="error in errors.kitFlag" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" class="form-check-input" id="freePickGift" v-model="freePickGift">
                          <label class="form-check-label" for="freePickGift">
                            Free Pick Gift </label>
                        </div>

                        <div v-if="errors.freePickGift">
                          <div v-for="error in errors.freePickGift" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>

                    </div>

                    <div class="row mb-2">
                      <div class="col-lg-3 required">

                        <label for="defaultconfig" class="col-form-label">Gross Weight</label>

                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.grossWeight" v-bind="digit">
                        </money> -->
                        <input
                            type="number"
                            class="form-control"
                            id="grossWeight"
                            step="any"
                            v-model="forms.grossWeight"
                            placeholder="0.00000"
                          />

                        <div v-if="errors.grossWeight">
                          <div v-for="error in errors.grossWeight" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>

                      <div class="col-lg-3 required">

                        <label for="defaultconfig" class="col-form-label">Net Weight</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.netWeight" v-bind="digit">
                        </money> -->
                        <input
                            type="number"
                            class="form-control"
                            id="netWeight"
                            step="any"
                            v-model="forms.netWeight"
                            placeholder="0.00000"
                          />

                        <div v-if="errors.netWeight">
                          <div v-for="error in errors.netWeight" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">Tare</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.tare" v-bind="digit"></money> -->
                        <input type="number"  step="any" class="form-control" id="tare" v-model="forms.tare" placeholder="0.00000"/>
                        <div v-if="errors.tare">
                          <div v-for="error in errors.tare" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>





                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">Price</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.price" v-bind="digit"></money> -->
                        <input type="number"  step="any" class="form-control" id="price" v-model="forms.price" placeholder="0.00000"/>
                        <div v-if="errors.price">
                          <div v-for="error in errors.price" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>


                    </div>


                    <div class="row mb-3">

                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">SKU Length</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.skuLength" @input="sumCube"
                          v-bind="digit"></money> -->
                        <input type="number"  step="any" class="form-control" @input="sumCube" id="skuLength" v-model="forms.skuLength" placeholder="0.00000"/>
                        <div v-if="errors.skuLength">
                          <div v-for="error in errors.skuLength" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">SKU Width</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.skuWidth" @input="sumCube"
                          v-bind="digit"></money> -->
                        <input type="number"  step="any" class="form-control" id="skuWidth" @input="sumCube" v-model="forms.skuWidth" placeholder="0.00000"/>
                        <div v-if="errors.skuWidth">
                          <div v-for="error in errors.skuWidth" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>


                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">SKU Height</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.skuHigh" @input="sumCube"
                          v-bind="digit"></money> -->
                        <input type="number"  step="any" class="form-control" id="skuWidth" @input="sumCube" v-model="forms.skuHigh" placeholder="0.00000"/>
                        <div v-if="errors.skuHigh">
                          <div v-for="error in errors.skuHigh" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>



                      

                      <div class="col-lg-3 required">
                        <label for="defaultconfig" class="col-form-label">Cube</label>
                        <!-- <money class="form-control" placeholder="0.00000" v-model="forms.cube" v-bind="digit"></money> -->
                        <input type="text" class="form-control" id="cube" v-model="forms.cube" placeholder="0.00000"/>
                        <div v-if="errors.cube">
                          <div v-for="error in errors.cube" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>






                    </div>

                    <div class="row mb-2">
                      <div class="card">
                        <div class="card-header">Shelf Life</div>



                        <div class="card-body">
                          <div class="row">

                            <div class="col-lg-3">
                          <label for="defaultconfig" class="col-form-label" >Shelf Life Type</label>
                            <v-select
                                  :options="fetchShelfLifeType"
                                  v-model="shelfLifeType"
                                  label="name"
                                  return-object
                                  
                                 
                                >
                                <template slot="option" slot-scope="option">
                                  {{option.code}} | {{option.name}}
                                </template>
                              </v-select>
                                <div v-if="errors.shelfLifeType">
                                  <div
                                    v-for="error in errors.shelfLifeType"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                        </div>


                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" >Shelf Life Unit</label>
                            <v-select
                                  :options="fetchShelfLifeUnit"
                                  v-model="shelfLifeUnit"
                                  label="code"
                                  return-object
                                 
                                >
                                <template slot="option" slot-scope="option">
                                  {{option.code}} | {{option.name}}
                                </template>
                              </v-select>
                                <div v-if="errors.shelfLifeUnit">
                                  <div
                                    v-for="error in errors.shelfLifeUnit"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                        </div>

                        <div class="col-lg-1">
                          <label for="defaultconfig" class="col-form-label" >Shelf Life</label>
                          <input type="number" class="form-control" id="shelfLife" v-model="forms.shelfLife" placeholder="0"/>
                                <div v-if="errors.shelfLife">
                                  <div
                                    v-for="error in errors.shelfLife"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                        </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Shelf Life Alert Days</label>
                              <input type="number" class="form-control" id="shelfLife" v-model="forms.shelfLifeAlertDays"
                                placeholder="0" />
                              <div v-if="errors.shelfLifeAlertDays">
                                <div v-for="error in errors.shelfLifeAlertDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Inbound Life Days</label>
                              <input type="number" class="form-control" id="shelfLife" v-model="forms.inboundLifeDays"
                                placeholder="0" />
                              <div v-if="errors.inboundLifeDays">
                                <div v-for="error in errors.inboundLifeDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Outbond Life Days</label>
                              <input type="number" class="form-control" id="shelfLife" v-model="forms.outboundLifeDays"
                                placeholder="0" />
                              <div v-if="errors.outboundLifeDays">
                                <div v-for="error in errors.outboundLifeDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label"></label>
                              <div class="form-check mb-3">
                                <input type="checkbox" class="form-check-input" id="shelfLifeFlag"
                                  v-model="shelfLifeFlag">
                                <label class="form-check-label" for="freePickGift">
                                  Shelf Life Flag </label>
                              </div>

                              <div v-if="errors.shelfLifeFlagt">
                                <div v-for="error in errors.shelfLifeFlag" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2 ">
                      <div class="card">
                        <div class="card-header">Alternate SKU</div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 1</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.alternate_sku1"
                                placeholder="" />
                              <div v-if="errors.alternate_sku1">
                                <div v-for="error in errors.alternate_sku1" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 2</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.alternate_sku2"
                                placeholder="" />
                              <div v-if="errors.alternate_sku2">
                                <div v-for="error in errors.alternate_sku2" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 3</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.alternate_sku3"
                                placeholder="" />
                              <div v-if="errors.alternate_sku3">
                                <div v-for="error in errors.alternate_sku3" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-3">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 4</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.alternate_sku4"
                                placeholder="" />
                              <div v-if="errors.alternate_sku4">
                                <div v-for="error in errors.alternate_sku4" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-3">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 5</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.alternate_sku5"
                                placeholder="" />
                              <div v-if="errors.alternate_sku5">
                                <div v-for="error in errors.alternate_sku5" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                          </div>




                        </div>
                      </div>
                    </div>



                    <div class="row mb-2">
                      <div class="card">
                        <div class="card-header">SKU Group</div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 1</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group1"
                                placeholder="" />
                              <div v-if="errors.sku_group1">
                                <div v-for="error in errors.sku_group1" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 2</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group2"
                                placeholder="" />
                              <div v-if="errors.sku_group2">
                                <div v-for="error in errors.sku_group2" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 3</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group3"
                                placeholder="" />
                              <div v-if="errors.sku_group3">
                                <div v-for="error in errors.sku_group3" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 4</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group4"
                                placeholder="" />
                              <div v-if="errors.sku_group4">
                                <div v-for="error in errors.sku_group4" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 5</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group5"
                                placeholder="" />
                              <div v-if="errors.sku_group5">
                                <div v-for="error in errors.sku_group5" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 6</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group6"
                                placeholder="" />
                              <div v-if="errors.sku_group6">
                                <div v-for="error in errors.sku_group6" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>









                          </div>


                          <div class="row">


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 7</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group7"
                                placeholder="" />
                              <div v-if="errors.sku_group7">
                                <div v-for="error in errors.sku_group7" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 8</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group8"
                                placeholder="" />
                              <div v-if="errors.sku_group8">
                                <div v-for="error in errors.sku_group8" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 9</label>
                              <input type="text" class="form-control" id="shelfLife" v-model="forms.sku_group9"
                                placeholder="" />
                              <div v-if="errors.sku_group9">
                                <div v-for="error in errors.sku_group9" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">Reserved Field</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 01</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField01" placeholder=""/>
                                        <div v-if="errors.reservedField01">
                                          <div
                                            v-for="error in errors.reservedField01"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 02</label>
                                  <input type="text" class="form-control" id="udf02" v-model="forms.reservedField02" placeholder=""/>
                                        <div v-if="errors.udf02">
                                          <div
                                            v-for="error in errors.udf02"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 03</label>
                                  <input type="text" class="form-control" id="udf03" v-model="forms.reservedField03" placeholder=""/>
                                        <div v-if="errors.reservedField03">
                                          <div
                                            v-for="error in errors.reservedField03"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 04</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField04" placeholder=""/>
                                        <div v-if="errors.reservedField04">
                                          <div
                                            v-for="error in errors.reservedField04"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 05</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField05" placeholder=""/>
                                        <div v-if="errors.reservedField05">
                                          <div
                                            v-for="error in errors.reservedField05"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 06</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField06" placeholder=""/>
                                        <div v-if="errors.reservedField06">
                                          <div
                                            v-for="error in errors.reservedField06"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 07</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField07" placeholder=""/>
                                        <div v-if="errors.reservedField07">
                                          <div
                                            v-for="error in errors.reservedField07"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 08</label>
                                  <input type="text" class="form-control" id="udf02" v-model="forms.reservedField08" placeholder=""/>
                                        <div v-if="errors.udf08">
                                          <div
                                            v-for="error in errors.udf08"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 09</label>
                                  <input type="text" class="form-control" id="udf03" v-model="forms.reservedField09" placeholder=""/>
                                        <div v-if="errors.reservedField09">
                                          <div
                                            v-for="error in errors.reservedField09"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 10</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField10" placeholder=""/>
                                        <div v-if="errors.reservedField10">
                                          <div
                                            v-for="error in errors.reservedField10"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 11</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField11" placeholder=""/>
                                        <div v-if="errors.reservedField11">
                                          <div
                                            v-for="error in errors.reservedField12"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 12</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField12" placeholder=""/>
                                        <div v-if="errors.reservedField12">
                                          <div
                                            v-for="error in errors.reservedField12"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 13</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField13" placeholder=""/>
                                        <div v-if="errors.reservedField13">
                                          <div
                                            v-for="error in errors.reservedField13"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 14</label>
                                  <input type="text" class="form-control" id="udf14" v-model="forms.reservedField14" placeholder=""/>
                                        <div v-if="errors.udf14">
                                          <div
                                            v-for="error in errors.udf14"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 15</label>
                                  <input type="text" class="form-control" id="udf03" v-model="forms.reservedField15" placeholder=""/>
                                        <div v-if="errors.reservedField15">
                                          <div
                                            v-for="error in errors.reservedField15"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 16</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField16" placeholder=""/>
                                        <div v-if="errors.reservedField16">
                                          <div
                                            v-for="error in errors.reservedField16"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 17</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField17" placeholder=""/>
                                        <div v-if="errors.reservedField17">
                                          <div
                                            v-for="error in errors.reservedField17"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 18</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField18" placeholder=""/>
                                        <div v-if="errors.reservedField18">
                                          <div
                                            v-for="error in errors.reservedField18"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row mb-2">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 19</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField19" placeholder=""/>
                                        <div v-if="errors.reservedField19">
                                          <div
                                            v-for="error in errors.reservedField19"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 20</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reservedField20" placeholder=""/>
                                        <div v-if="errors.reservedField20">
                                          <div
                                            v-for="error in errors.reservedField20"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                              </div>


                          </div>
                        </div>
                      </div>


                      <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">User Define</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 1</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.udf01" placeholder=""/>
                                        <div v-if="errors.udf01">
                                          <div
                                            v-for="error in errors.udf01"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 2</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.udf02" placeholder=""/>
                                        <div v-if="errors.udf02">
                                          <div
                                            v-for="error in errors.udf02"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 3</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.udf03" placeholder=""/>
                                        <div v-if="errors.udf03">
                                          <div
                                            v-for="error in errors.udf03"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 4</label>
                                  <input type="text" class="form-control" id="udf04" v-model="forms.udf04" placeholder=""/>
                                        <div v-if="errors.udf04">
                                          <div
                                            v-for="error in errors.udf04"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>



                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 5</label>
                                  <input type="text" class="form-control" id="udf04" v-model="forms.udf05" placeholder=""/>
                                        <div v-if="errors.udf05">
                                          <div
                                            v-for="error in errors.udf05"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                               

                              
                              


                              

                             

                               

                                

                                



                              </div>


                            
                          </div>
                        </div>
                      </div>



                      <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">Other</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Freight Class</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.freightClass" placeholder=""/>
                                        <div v-if="errors.freightClass">
                                          <div
                                            v-for="error in errors.freightClass"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Report Uom</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.reportUom" placeholder=""/>
                                        <div v-if="errors.reportUom">
                                          <div
                                            v-for="error in errors.reportUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-3">
                                  <label for="defaultconfig" class="col-form-label" >Default Shipment Uom</label>
                                  <input type="text" class="form-control" id="udf01" v-model="forms.defaultShipmentUom" placeholder=""/>
                                        <div v-if="errors.defaultShipmentUom">
                                          <div
                                            v-for="error in errors.defaultShipmentUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-3">
                                  <label for="defaultconfig" class="col-form-label" >Default Receiving Uom</label>
                                  <input type="text" class="form-control" id="defaultReceivingUom" v-model="forms.defaultReceivingUom" placeholder=""/>
                                        <div v-if="errors.defaultReceivingUom">
                                          <div
                                            v-for="error in errors.defaultReceivingUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>




                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Pack Id</label>
                                  <input type="text" class="form-control" id="udf04" v-model="forms.packId" placeholder=""/>
                                        <div v-if="errors.packId">
                                          <div
                                            v-for="error in errors.packId"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                               

                              
                              


                              

                             

                               

                                

                                



                              </div>


                            
                          </div>
                        </div>
                      </div>

                    <div class="row mb-2">
                      <div class="col-lg-12">
                        <label for="defaultconfig" class="col-form-label">Note </label>
                        <textarea name="noteText" class="form-control" v-model="forms.noteText"></textarea>
                        <div v-if="errors.noteText">
                          <div v-for="error in errors.noteText" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>





                    <div class="card-footer">
                      <button class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          " @click="backForm" type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>


                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CmlTarifEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      fetchshelfLifeUnit: [
        {
          'name': 'YEAR',
        },
        {
          'name': 'MONTH',
        },
        {
          'name': 'DAY',
        }],
      shelfLifeUnit: '',
      shelfLifeType:'',
      digit: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: '',
        precision: 5,
        masked: false
      },
      company_type: "",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      company_group: "",
      fetchStatus: ['ACTIVE', 'DEACTIVE'],
      fetchmultiWhFlag: ['Y', 'N'],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
      forms: {},
      userData: "",
      userRole: "",
      fetchShelfLifeType: [],
      fetchShelfLifeUnit: [],
      activeFlag : false,
      shelfLifeFlag : false,
      kitFlag : false,
      freePickGift : false,
    };
  },
  watch: {},
  methods: {


    loadCustomer() {

      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },



    loadShelfLifeType() {

      const baseURI = this.$settings.endPointFluxOms + "v2/sku/shelf-type";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchShelfLifeType = response.data.datas;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    loadShelfLifeUnit() {

      const baseURI = this.$settings.endPointFluxOms + "v2/sku/date-unit";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchShelfLifeUnit = response.data.datas;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms?code=" + code;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


   


    asyncSearchFulfillment() {


      const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/get-data?download=all";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    asyncSearchCustomer() {

      const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/customer/get-data?download=all";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    resetForm() {

      this.forms.idTarifMasterHeader = "";
      this.forms.tarifMasterId = "";
      this.forms.customerId = "";
      this.forms.status = "";
      this.forms.multiWhFlag = "N";
      this.forms.queryRateHeader = "";
      this.forms.addwho = "";
      this.forms.editwho = "";
      this.forms.adddate = "";
      this.forms.editdate = "";

    },

    backForm() {
      window.location.href = "/flux-oms/master-sku";
    },

    sumCube() {

    var a=this.forms.skuLength;
    var b=this.forms.skuHigh;
    var c=this.forms.skuWidth;

    // var skuLength= parseFloat(a?.replace('.', ''));
    // var skuHigh= parseFloat(b?.replace('.', ''));
    // var skuWidth= parseFloat(c?.replace('.', ''));

    // console.log(skuLength);
    // console.log(skuHigh);
    // console.log(skuWidth);
    var total = a * b * c;


    this.forms.cube=total;
    

    },

    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/detail/" + id;

      return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        this.isLoading = false;
        this.forms = response.data.datas;
        this.customer = {
          'customer_id': this.forms.customer_id,
          'code': this.forms.customerId,
          'name': this.forms.customerId
        }

       


        if(this.forms.shelfLifeUnit==null){
          this.shelfLifeUnit=undefined;
        }else{
          this.shelfLifeUnit = {
            'code': this.forms.shelfLifeUnit
          }
        }


          this.shelfLifeType = {
            'code': this.forms.shelfLifeType,
            'name': this.forms.shelf_life_type.name
          }
        console.log(this.shelfLifeType);
      
        // console.log(this.customer);

        this.activeFlag = this.forms.activeFlag == 'Y' ? true : false;
        this.shelfLifeFlag = this.forms.shelfLifeFlag == 'Y' ?  true : false;
        this.kitFlag = this.forms.kitFlag == 'Y' ? true: false;
        this.freePickGift = this.forms.freePickGift == 'Y' ? true: false;
    

        // this.fulfillment    = response.data.datas.fulfillment

      }).catch(error => {

        this.loading();

        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        }

      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'SkuController') {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
      this.loadCustomer();

    },

    submitData() {
      this.isLoading = true;



      this.forms.customer_id = this.customer.customer_id;
      this.forms.customerId = this.customer.code;

      this.forms.activeFlag = this.activeFlag == true ? 'Y' : 'N';
      this.forms.shelfLifeFlag = this.shelfLifeFlag == true ? 'Y' : 'N';
      this.forms.kitFlag = this.kitFlag == true ? 'Y' : 'N';
      this.forms.freePickGift = this.freePickGift == true ? 'Y' : 'N';
      // this.forms.shelfLifeUnit=this.shelfLifeUnit?.code;
      this.forms.shelfLifeUnit=this.shelfLifeUnit?.code;
      this.forms.shelfLifeType=this.shelfLifeType?.code;
     
    //  console.log(this.forms.shelfLifeUnit);
    //  console.log(this.forms.shelfLifeType);



      const baseURI = this.$settings.endPointFluxOms + "v2/sku/update/" + this.forms.BAS_SKU_ID;
      this.$http.patch(baseURI, this.forms, { timeout: 10000 }).then((response) => {
        this.loading();
        if (response.data.status === 200) {
          //this.resetForm();
          this.isLoading = false;
          this.errors = [];
          //console.log(response.data.datas.user_id);
          //var params = this.$onRandom(response.data.datas.BAS_SKU_ID);
          window.location.href = "/flux-oms/master-sku";
          this.success('Berhasil');
        } else {
          this.isLoading = false;
          this.errors = response.data.errors;
          this.resultError(response.data.errors);
        }
      }).catch(error => {
        this.loading();
        this.isLoading = false;
        if (error.code == "ECONNABORTED") {
          this.error("Please Check Your Internet Connection");
        }

        if (error.response) {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.resultError(error.response.data.errors);
          } else if (error.response.status === 401) {
            this.logout();
          } else if (error.response.status === 403) {
            this.$router.push("/authorized-error");
          } else if (error.response.status === 500) {
            this.$router.push('/server-error');
          } else {
            this.$router.push('/page-not-found');
          }
        }
        //this.resetForm();
      });

    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

  },
  events: {},
  created: function () { },
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadShelfLifeType();
    this.loadShelfLifeUnit();
    this.fetchIt();
  },
};
</script>
<style scoped>
  
.required label {
  font-weight: bold;
}
.required label:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>